import type React from 'react'

import { css } from '@portal/styled-system/css'

import { env } from '@/shared/config'
import { useActiveLaw } from '@/shared/lib/cookieyes/provider/use-active-law'
import { SelectCookiesButton } from '@/shared/lib/cookieyes/select-cookies-button'
import { useI18n } from '@/shared/lib/i18n'
import { getLegalLinkHref } from '@/shared/lib/legal-link'
import { Link } from '@/shared/ui'
import { Dropdown } from '@/shared/ui/dropdown'

export function FooterLinkList() {
    const { i18n, lang } = useI18n()

    return (
        <ul
            className={css({
                listStyle: 'none',
                display: 'flex',
                gap: '3',
                marginBottom: '0',
                paddingRight: '3',
            })}
        >
            <li>
                <FooterLegalLink path="terms-of-service/">{i18n.LINK_LEGAL_TERMS__SHORT}</FooterLegalLink>
            </li>
            <li>
                <FooterLegalLink path="privacy-policy/">{i18n.LINK_LEGAL_PRIVACY__SHORT}</FooterLegalLink>
            </li>

            <li>
                <CookiesFooterDropdown />
            </li>

            {lang === 'de' && (
                <li>
                    <FooterLegalLink path="impressum/">{i18n.LINK_IMPRESSUM}</FooterLegalLink>
                </li>
            )}

            {lang === 'ja' && (
                <li>
                    <FooterLegalLink path="notation/">{i18n.LINK_NOTATION_JP}</FooterLegalLink>
                </li>
            )}
        </ul>
    )
}

const dropdownItemStyles = css({
    display: 'block',
    height: '4',
    paddingX: '4',
    paddingY: '1',
    lineHeight: 'snug',
    color: 'gray.600',
    whiteSpace: 'nowrap',
    cursor: 'pointer',

    _hover: {
        backgroundColor: 'transparent',
        color: 'blue.300',
        textDecoration: 'underline',
    },
})

function CookiesFooterDropdown() {
    const { i18n, lang } = useI18n()

    const activeLaw = useActiveLaw()

    if (activeLaw === '') {
        return <FooterLegalLink path="cookies/">{i18n.LINK_LEGAL_COOKIES}</FooterLegalLink>
    }

    return (
        <Dropdown
            title={activeLaw === 'ccpa' ? i18n.LINK_LEGAL_COOKIES__SHORT_CCPA : i18n.LINK_LEGAL_COOKIES__SHORT}
            titleClassName={css({
                whiteSpace: 'nowrap',
                _hover: {
                    textDecoration: 'underline',
                },
            })}
        >
            {env.COOKIEYES_SITE_ID && activeLaw && <SelectCookiesButton as="a" className={dropdownItemStyles} />}
            <Link
                href={getLegalLinkHref(lang, 'cookies/')}
                target="_blank"
                rel="noreferrer"
                className={dropdownItemStyles}
            >
                {i18n.LINK_LEGAL_COOKIES}
            </Link>
        </Dropdown>
    )
}

function FooterLegalLink({ path, children }: React.PropsWithChildren<{ path: string }>) {
    const { lang } = useI18n()

    return (
        <Link
            href={getLegalLinkHref(lang, path)}
            target="_blank"
            rel="noreferrer"
            className={css({
                color: 'footer.font',
            })}
        >
            {children}
        </Link>
    )
}
